/* __next_internal_client_entry_do_not_use__ EventsThemeLogo auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { MarketPrimaryLogo } from "@faire/web--source/slate/icons/faire-markets/MarketPrimaryLogo";
import { MarketSecondaryLogo } from "@faire/web--source/slate/icons/faire-markets/MarketSecondaryLogo";
import { SummerMarketPrimaryLogo } from "@faire/web--source/slate/icons/faire-markets/SummerMarketPrimaryLogo";
import { WinterMarketPrimaryLogo } from "@faire/web--source/slate/icons/faire-markets/WinterMarketPrimaryLogo";
import { WinterMarketSecondaryLogo } from "@faire/web--source/slate/icons/faire-markets/WinterMarketSecondaryLogo";
import { withAutoDimension } from "@faire/web--source/slate/Theme/withAutoDimension";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import React from "react";
import { getEventTheme } from "./eventsThemeColors";
var PrimaryMarketBase = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(MarketPrimaryLogo, {
        isInverse: isInverse,
        height: height,
        width: width,
        iconColor: iconColor,
        className: className
    });
};
var PrimaryMarketBaseFsm23 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(MarketPrimaryLogo, {
        isInverse: isInverse,
        height: height,
        width: width,
        iconColor: iconColor !== null && iconColor !== void 0 ? iconColor : getEventTheme(PromotionalEventType.FAIRE_MARKET_JULY_2023).badgeIcon,
        className: className
    });
};
var PrimaryMarketBaseFwm23 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(WinterMarketPrimaryLogo, {
        isInverse: isInverse,
        height: height,
        width: width,
        iconColor: iconColor,
        className: className
    });
};
var PrimaryMarketBaseFsm22 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(SummerMarketPrimaryLogo, {
        height: height,
        width: width,
        lightBackground: !isInverse,
        sunColor: iconColor,
        className: className
    });
};
var PrimaryMarket = withAutoDimension(PrimaryMarketBase);
var PrimaryMarketFsm23 = withAutoDimension(PrimaryMarketBaseFsm23);
var PrimaryMarketFwm23 = withAutoDimension(PrimaryMarketBaseFwm23);
var PrimaryMarketFsm22 = withAutoDimension(PrimaryMarketBaseFsm22);
var SecondaryMarketBase = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(MarketSecondaryLogo, {
        height: height,
        width: width,
        isInverse: isInverse,
        iconColor: iconColor,
        className: className
    });
};
var SecondaryMarketBaseFsm23 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(MarketSecondaryLogo, {
        height: height,
        width: width,
        isInverse: isInverse,
        iconColor: iconColor !== null && iconColor !== void 0 ? iconColor : getEventTheme(PromotionalEventType.FAIRE_MARKET_JULY_2023).badgeIcon,
        className: className
    });
};
var SecondaryMarketBaseFwm23 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(WinterMarketSecondaryLogo, {
        height: height,
        width: width,
        isInverse: isInverse,
        iconColor: iconColor,
        className: className
    });
};
var SecondaryMarketBaseFsm22 = function(param) {
    var height = param.height, width = param.width, isInverse = param.isInverse, iconColor = param.iconColor, className = param.className;
    return /*#__PURE__*/ _jsx(SummerMarketPrimaryLogo, {
        height: height,
        width: width,
        lightBackground: !isInverse,
        sunColor: iconColor,
        className: className
    });
};
var SecondaryMarket = withAutoDimension(SecondaryMarketBase);
var SecondaryMarketFsm23 = withAutoDimension(SecondaryMarketBaseFsm23);
var SecondaryMarketFwm23 = withAutoDimension(SecondaryMarketBaseFwm23);
var SecondaryMarketFsm22 = withAutoDimension(SecondaryMarketBaseFsm22);
export var EventsThemeLogo = {
    faireMarket: {
        primary: PrimaryMarket,
        secondary: SecondaryMarket
    },
    FAIRE_MARKET_JULY_2023: {
        primary: PrimaryMarketFsm23,
        secondary: SecondaryMarketFsm23
    },
    FAIRE_WINTER_MARKET_2023: {
        primary: PrimaryMarketFwm23,
        secondary: SecondaryMarketFwm23
    },
    FAIRE_SUMMER_MARKET_2022: {
        primary: PrimaryMarketFsm22,
        secondary: SecondaryMarketFsm22
    }
};
